module.exports = __webpack_public_path__ + "static/media/close.953c0dfb.svg";